import React from "react";
import { HiInformationCircle } from "react-icons/hi";
import { CustomButton } from "../atoms/CustomButton";
import { ModalShell } from "../atoms/ModalShell";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

interface BadgeVerificationErrorModalProps {
  show: boolean;
  onClose: () => void;
}

const BadgeVerificationErrorModal: React.FC<
  BadgeVerificationErrorModalProps
> = ({ show, onClose }) => {
  const { t } = useTranslation();

  return (
    <ModalShell
      show={show}
      onClose={onClose}
      size="md"
      footer={
        <CustomButton
          onClick={onClose}
          title={t("dashboard.features.lmc.badgeVerification.error.close")}
          variant="primary"
        />
      }
    >
      <div className="flex flex-col gap-3">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
          <HiInformationCircle size={24} className="text-blue-600" />
        </div>

        <div className="flex flex-col gap-2">
          <div className="text-gray-900 text-lg font-semibold leading-7">
            {t("dashboard.features.lmc.badgeVerification.error.title")}
          </div>
          <div className="text-gray-500 text-sm leading-tight">
            {parse(
              t("dashboard.features.lmc.badgeVerification.error.notReady")
            )}
          </div>
        </div>
      </div>
    </ModalShell>
  );
};

export default BadgeVerificationErrorModal;
